import React, { memo } from 'react';
import { Link } from 'wouter';
import { motion } from 'framer-motion';
import TrustBadges from './TrustBadges';

const FOOTER_LINKS = {
  company: [
    { href: '/', label: 'Home' },
    { href: '/about', label: 'About Us' },
    { href: '/portfolio', label: 'Portfolio' },
    { href: '/blog', label: 'Blog' },
    { href: '/contact', label: 'Contact' },
    { href: '/sitemap', label: 'Sitemap' },
    { href: '/sitemap.xml', label: 'Sitemap.xml' },
    { href: '/robots.txt', label: 'robots.txt' },
  ],
  services: [
    { href: '/services/web-design', label: 'Web Design' },
    { href: '/services/web-development', label: 'Web Development' },
    { href: '/services/e-commerce', label: 'E-Commerce' },
    { href: '/services/seo-strategy', label: 'SEO Services' },
    { href: '/services/web-hosting', label: 'Web Hosting' },
    { href: '/enquiry', label: 'Request Quote' },
  ],
  resources: [
    { href: '/guides', label: 'Guides' },
    { href: '/faq', label: 'FAQ' },
    { href: '/support', label: 'Support' },
    { href: '/sitemap', label: 'Sitemap' },
    { href: '/sitemap.xml', label: 'Sitemap.xml' },
    { href: '/robots.txt', label: 'robots.txt' },
  ],
};

const SOCIAL_LINKS = [
  {
    name: 'Facebook',
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
        <path
          fillRule="evenodd"
          d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
          clipRule="evenodd"
        />
      </svg>
    ),
  },  
  {  
    name: 'Twitter',
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
        <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
      </svg>
    ),
  },
  {
    name: 'Instagram',
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
        <path
          fillRule="evenodd"
          d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
          clipRule="evenodd"
        />
      </svg>
    ),
  },
  {
    name: 'LinkedIn',
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
      </svg>
    ),
  },
];

interface FooterLinkColumnProps {
  title: string;
  links: { href: string; label: string }[];
}

const FooterLinkColumn = memo(function FooterLinkColumn({
  title,
  links,
}: FooterLinkColumnProps) {
  return (
    <nav aria-label={`${title} links`}>
      <h2 className="text-lg font-bold mb-4 text-white">{title}</h2>
      <ul className="space-y-2" role="list">
        {links.map((link) => (
          <li key={link.label} role="listitem">
            <Link
              href={link.href}
              className="text-gray-200 hover:text-primary transition-colors duration-200 hover:translate-x-1 inline-block focus:outline-none focus:text-primary"
            >
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
});

/**
 * Footer component with company info, navigation links, and contact details.
 * Extracted from Layout for better maintainability.
 */
const Footer = memo(function Footer() {
  return (
    <footer className="bg-gray-900 text-white" role="contentinfo" aria-label="Site footer">
      {/* Main Footer Content */}
      <div className="pt-12 pb-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-8">
            {/* Company Info */}
            <div className="col-span-1 md:col-span-2 lg:col-span-1">
              <div className="mb-4">
                <img
                  src="/assets/logo/Logo-footer.png"
                  alt="Digital Web Builders"
                  className="h-24 w-auto"
                />
              </div>
              <p className="text-gray-400 mb-6">
                Creating exceptional digital experiences for modern businesses,
                helping you stand out in the digital world.
              </p>
              <div className="flex space-x-3" role="list" aria-label="Social media links">
                {SOCIAL_LINKS.map((social, index) => (
                  <motion.a
                    key={social.name}    
                    href="#"
                    className="w-9 h-9 rounded-full bg-gray-800 hover:bg-primary/20 flex items-center justify-center text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-gray-900"
                    aria-label={`Follow us on ${social.name}`}
                    role="listitem"
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.1, duration: 0.3 }}
                    whileHover={{ scale: 1.15, rotate: 5 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    {social.icon}
                  </motion.a>
                ))}
              </div>
            </div>

            {/* Link Columns */}
            <FooterLinkColumn title="Company" links={FOOTER_LINKS.company} />
            <FooterLinkColumn title="Services" links={FOOTER_LINKS.services} />
            <FooterLinkColumn title="Resources" links={FOOTER_LINKS.resources} />

            {/* Contact Column */}
            <div>
              <h4 className="text-lg font-bold mb-4 text-white">Contact Us</h4>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <svg
                    className="w-5 h-5 text-primary mt-0.5 mr-3 flex-shrink-0"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                  </svg>
                  <span className="text-gray-400">hello@webbuilders.live</span>
                </li>
                <li className="flex items-start">
                  <svg
                    className="w-5 h-5 text-primary mt-0.5 mr-3 flex-shrink-0"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                  </svg>
                  <span className="text-gray-400">+233 593 392 825</span>
                </li>
                <li className="flex items-start">
                  <svg
                    className="w-5 h-5 text-primary mt-0.5 mr-3 flex-shrink-0"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="text-gray-400">Digital Web Builders & Consultancy</span>
                </li>
              </ul>

              <div className="mt-6">
                <Link href="/enquiry">
                  <motion.span
                    className="inline-block bg-primary text-white px-5 py-2.5 rounded-lg font-medium cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-gray-900"
                    whileHover={{ scale: 1.05, boxShadow: '0 4px 20px rgba(var(--primary), 0.3)' }}
                    whileTap={{ scale: 0.98 }}
                    transition={{ type: 'spring', stiffness: 400, damping: 17 }}
                  >
                    Get A Free Quote
                  </motion.span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Trust Badges */}
      <div className="bg-black/20 py-6">
        <div className="container mx-auto px-4">
          <TrustBadges variant="footer" />
        </div>
      </div>

      {/* Bottom Copyright Bar */}
      <div className="bg-black/30 py-4">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-3">
            <p className="text-gray-400 text-xs sm:text-sm text-center md:text-left">
              &copy; {new Date().getFullYear()} Digital Web Builders & Consultancy
              Ltd. All rights reserved.
            </p>
            <div className="flex flex-wrap justify-center gap-3 sm:gap-4">
              <Link
                href="/privacy-policy"
                className="text-gray-400 hover:text-primary text-sm"
              >
                Privacy Policy
              </Link>
              <Link
                href="/terms-of-service"
                className="text-gray-400 hover:text-primary text-sm"
              >
                Terms of Service
              </Link>
              <Link
                href="/cookie-policy"
                className="text-gray-400 hover:text-primary text-sm"
              >
                Cookie Policy
              </Link>
              <Link
                href="/sitemap"
                className="text-gray-400 hover:text-primary text-sm"
              >
                Sitemap
              </Link>
              <Link
                href="/sitemap.xml"
                className="text-gray-400 hover:text-primary text-sm"
              >
                Sitemap.xml
              </Link>
              <Link
                href="/robots.txt"
                className="text-gray-400 hover:text-primary text-sm"
              >
                robots.txt
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
});

Footer.displayName = 'Footer';

export default Footer;
